import { render, staticRenderFns } from "./TherapistItem.vue?vue&type=template&id=d05e9844&scoped=true&"
import script from "./TherapistItem.vue?vue&type=script&lang=js&"
export * from "./TherapistItem.vue?vue&type=script&lang=js&"
import style0 from "./TherapistItem.vue?vue&type=style&index=0&id=d05e9844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05e9844",
  null
  
)

export default component.exports